import styled from "styled-components";
import CompactTable, {
  leftColumnPrimaryStyle,
  leftColumnSecondaryStyle,
  rightColumnPrimaryStyle,
  rightColumnSecondaryStyle,
} from "../../components/organisms/CompactTable";
import { removalReportOutputParams as params } from "../../lib/gpConfig";
import { Label, UnitSpan, Value } from "../../components/atoms/Text";
import { reportEmptyDetailValues } from "../../lib/constants"

const Container = styled.div`
  padding-inline: 12px;
  margin-bottom: 8px;
  font-size: 14px;
`;

const DetailsValue = styled(Value)`
  text-transform: capitalize;
`;

const DetailsValueBlock = styled(DetailsValue)`
  display: block;
`;

const leftPrimaryStyle = { width: "75%", ...leftColumnPrimaryStyle };
const rightPrimaryStyle = { width: "25%", ...rightColumnPrimaryStyle };
const leftSecondaryStyle = { width: "75%", ...leftColumnSecondaryStyle };
const rightSecondaryStyle = { width: "25%", ...rightColumnSecondaryStyle };

const primaryRowStyles = [leftPrimaryStyle, rightPrimaryStyle];
const secondaryRowStyles = [leftSecondaryStyle, rightSecondaryStyle];

interface IProps {
  locationResults: any;
  removalResults: any;
}

function OffsetRequirements({ locationResults, removalResults }: IProps) {
  const getRowData = (param: string) => {
    const { key, label, unit } = (params as any)[param];
    const fullLabel = (
      <span key={key}>
        {label}
        {unit && <UnitSpan>({unit})</UnitSpan>}
      </span>
    );
    let value = removalResults[key].value;
    return [fullLabel, value];
  };

  const lgasArray = locationResults.localGovernmentAreas.value;
  const lgas = lgasArray.length > 0
    ? lgasArray.map((x: string) => x.toLowerCase() + " LGA").join(", ")
    : reportEmptyDetailValues.lgas;
  const cmas = locationResults.catchmentManagementAuthorities.value
    .map((x: string) => x.toLowerCase() + " CMA")
    .join(", ");

  const rows: any = [
    {
      rowData: getRowData("generalOffsetAmount"),
      rowStyles: primaryRowStyles,
    },
    {
      rowData: getRowData("minimumStrategicBiodiversityScore"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("treesLargeCount"),
      rowStyles: secondaryRowStyles,
    },
  ];

  if (removalResults.patchTreesArea.value === 0) {
    delete rows[3];
  }

  return (
    <Container>
      <div>
        <Label>Vicinity</Label>
        <DetailsValueBlock>{lgas}</DetailsValueBlock>
        <DetailsValueBlock
          style={{ fontStyle: "italic", textTransform: "lowercase" }}
        >
          or
        </DetailsValueBlock>
        <DetailsValueBlock>{cmas}</DetailsValueBlock>
      </div>
      <CompactTable
        rows={rows}
        getRowKey={(row: any) => row[0].key}
      ></CompactTable>
    </Container>
  );
}

export default OffsetRequirements;
